import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});
